import * as React from "react";
import { useTranslation } from "react-i18next";
import SectionComponent from "components/common/Section/SectionComponent";
import { LinkContainer, ReadOnlyFormGroup } from "components/common";
import Routes from "routing/Routes";
import { Button, Alert, ButtonToolbar } from "components/bootstrap";
import LicenseCheck from "license/LicenseCheck";
import getDisplayName from "authentication/helpers/getDisplayName";
import { AUTH_SERVICE_TYPE } from "authentication/components/saml/constants";
const SAMLTeamSyncConfigSection = ({ authenticationBackend }) => {
  const { t } = useTranslation("enterprise_authentication");
  const { id, teamSyncIsCurrentlyEnabled, teamSyncGroupAttributeName, teamSyncAllowedGroups } = authenticationBackend;
  const displayName = getDisplayName(AUTH_SERVICE_TYPE);
  return /* @__PURE__ */ React.createElement(
    SectionComponent,
    {
      title: t("saml.saml_team_sync_config_section.title"),
      headerActions: /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.SYSTEM.AUTHENTICATION.BACKENDS.edit(id, "team_sync") }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "small" }, t("saml.saml_team_sync_config_section.edit"))))
    },
    teamSyncIsCurrentlyEnabled ? /* @__PURE__ */ React.createElement(LicenseCheck, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("saml.saml_team_sync_config_section.enabled"), value: true }), /* @__PURE__ */ React.createElement(
      ReadOnlyFormGroup,
      {
        label: t("saml.saml_team_sync_config_section.group_attribute_name"),
        value: teamSyncGroupAttributeName || /* @__PURE__ */ React.createElement("em", null, t("saml.saml_team_sync_config_section.auto_detect"))
      }
    ), /* @__PURE__ */ React.createElement(
      ReadOnlyFormGroup,
      {
        label: t("saml.saml_team_sync_config_section.allowed_groups"),
        value: teamSyncAllowedGroups || /* @__PURE__ */ React.createElement("em", null, t("saml.saml_team_sync_config_section.all"))
      }
    )) : /* @__PURE__ */ React.createElement(Alert, null, t("saml.saml_team_sync_config_section.not_configured", { displayName }))
  );
};
export default SAMLTeamSyncConfigSection;
